<script setup>
import {reactive, onMounted, onUnmounted, ref} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {Permissions} from "@/Utils/Permissions";
import {activeComponentStore} from "@/Stores/ActiveComponentStore";
import {ToastUtil} from "@/Utils/ToastUtil";

const compName = 'Disbursements_MiscComponent';

const props = defineProps({
    contextSchemaA: String,
    contextIdA: String
});

const form = ref(null);
const ruleForm = ref(null);
const descriptionOptions = [
    'Adjuster',
    'Reviewer',
    'E&O Reduction',
    'Flat Rate Fee',
    'Mileage',
    'Non Billable Mileage',
    'Misc.',
    'Time'
]

  const data = reactive({
    total: 0,
    adminFee: 0,
    editingFixed: false,
    editedFixed: null,
    editingRuleItem: false,
    editedRuleItem: {
      drulecategory: null,
      druleid: null,
      drulerole: null,
      druletype: null,
      drulevalue: null
    },
    valid: true,
    expanded: [],
    singleExpand: true,
    loading: false,
    dataLoading: true,
    newDisb: false,
    headers: [
      {
        title: 'Person',
        align: 'left',
        key: 'name',
      },
      {
        title: 'Total',
        key: 'amountReal',
      },
      {
        title: 'Preview Total',
        key: 'previewAmount',
      },
      { title: '', key: 'data-table-expand' },
    ],
    lines: [],
    people: [],
    peopleRows: [],
    newItem: {
      amount: null,
      description: null,
      personid: null,
    },
    totalPaid: null,
    nonHiddenAdmin: null,
    ruleValid: true,
    newRule: false,
    types: ['Assigned', 'All'],
    ruleHeaders: [
      {
        title: 'Person',
        align: 'left',
        key: 'role',
      },
      { title: 'Description', key: 'description' },
      { title: 'Edit', key: 'actions' },
    ],
    ruleLines: [],
    rulePeople: [],
    percent: 0,
    ruleCategories: ['Flat Rate Fee', 'Mileage', 'Misc.', 'Non Certified Adjustment', 'Time'],
    newRuleItem: {
      name: null,
      type: null,
      value: null,
      category: null,
    },
  });

  const getAdminData = () => {
    data.loading = true
    ApiWrapper.post('admin-fee', 'get-company-total', {claimId: props.contextIdA})
        .then((response) => {
          data.loading = false
          data.nonHiddenAdmin = response.nonHiddenAdmin
          data.totalPaid = response.totalPaid
          data.total = response.total
          data.percent = response.percent
          if(response.adminfee === null){
            data.adminFee = 0
            updateFee(true)
          }else{
            data.adminFee = response.adminfee.toFixed(2)
          }

        })
        .catch((e)=>{
          ToastUtil.error(e);
        })
        .finally(()=>{
          data.dataLoading = false;
          data.loading = false;
        })
  }

  const updateFee = (ignoreToast) => {
    data.dataLoading = true
    ApiWrapper.post('admin-fee', 'change-fee', {
          claimId: props.contextIdA,
          fee: data.adminFee
        })
        .then((response) => {
          getData();
          getRuleData();
          getAdminData();
          data.dataLoading = false;
          data.loading = false;

          if(!ignoreToast) {
            ToastUtil.successMsg('Updated admin fee');
          }
        })
        .catch((err) => {
          if(!ignoreToast) {
            ToastUtil.error(err);
          }
          data.dataLoading = false;
          data.loading = false;
        })
  }

  const getData = () => {
    data.dataLoading = true
    ApiWrapper.get(
            'disbursements-misc',
            'disbursements-misc','claimId=' + props.contextIdA
        )
        .then((response) => {
          data.lines = response.items
          for(let x in data.lines){
            if(data.lines[x].druletype !== null){
              if(data.lines[x].druletype.toLowerCase() === '% of work'){
                data.lines[x].druletype = 'All'
              }
              if(data.lines[x].druletype.toLowerCase() === '% of category'){
                data.lines[x].druletype = 'Assigned'
              }
            }
          }
          data.people = response.peopleNames.map(function (obj) {
            return obj
          });
          data.peopleRows = response.people;
          data.invoices = response.invoices.map(function (obj) {
            return obj.id
          })
          getPreviews()
          data.dataLoading = false;
          data.loading = false;
        })
        .catch((e)=>{
          ToastUtil.error(e);
        })
        .finally(()=>{
          data.dataLoading = false;
        })
  }

  const cancelEdit = () => {
    data.editedRuleItem = {}
    data.editingRuleItem = false
  }

  const editRuleItem = () => {
    data.dataLoading = true;
    ApiWrapper.post('disbursement-rules', 'edit', {
          value: data.editedRuleItem.drulevalue,
          name: data.editedRuleItem.drulerole,
          type: data.editedRuleItem.druletype,
          category: data.editedRuleItem.drulecategory,
          id: data.editedRuleItem.druleid,
          claimId: props.contextIdA
        })
        .then((response) => {
          data.editingRuleItem = false;
          getRuleData();
          getAdminData();
          getData();
          data.dataLoading = false;
          data.loading = false;

          ToastUtil.successMsg('Updated disbursement rule');
        })
        .catch((err) => {
          ToastUtil.error(err);
          data.dataLoading = false;
          data.loading = false;
        });
  }

  const getPreviews = () => {
    let uniquePeople = []
    for(let x in data.lines){
      if(uniquePeople.indexOf(data.lines[x].name) === -1){
        uniquePeople.push({name: data.lines[x].name, amount: 0, amountReal: 0})
      }
    }

    for(let x in uniquePeople){
      for(let y in data.lines){
        if(uniquePeople[x].name === data.lines[y].name){
          if(data.lines[y].invoiceid === 'Preview' || data.lines[y].invoiceid === 'Manual Entry Preview'){
            uniquePeople[x].amount += (data.lines[y].amountnum * 1)
          }else{
            uniquePeople[x].amountReal += (data.lines[y].amountnum * 1)
          }
        }
      }
    }

    for(let x in data.peopleRows){
      for(let y in uniquePeople){
        if(uniquePeople[y].name === data.peopleRows[x].name){
          data.peopleRows[x].previewAmount = '$' + uniquePeople[y].amount.toFixed(2);
          data.peopleRows[x].amountReal = '$' + uniquePeople[y].amountReal.toFixed(2)
        }
      }
    }
    data.loading = false
    data.dataLoading = false
  }

  const deleteItem = (item) => {
    let deleteMessage = confirm(
        'Are you sure you want to delete this item?'
    )
    if (deleteMessage === true) {
      data.loading = true
      ApiWrapper.post('disbursements-misc', 'delete', {
            id: item.id,
            newDisbursement:{
              personid: item.personid
            },
            claimId: props.contextIdA
          })
          .then((response) => {
            getData();
            getRuleData();
            getAdminData();
            data.dataLoading = false;
            data.loading = false;
            ToastUtil.successMsg('Deleted disbursement rule');
          })
          .catch((err) => {
            ToastUtil.error(err);
            data.dataLoading = false;
            data.loading = false;
          });
    }
  }

  const editFixed = () => {
    data.loading = true
    ApiWrapper.post('disbursements-misc', 'edit', {
          editedDisb: data.editedFixed
        })
        .then((response) => {
          getData();
          getAdminData();
          getRuleData();
          data.editingFixed = false
          data.dataLoading = false;
          data.loading = false;
          ToastUtil.successMsg('Updated disbursement');
        })
        .catch((err) => {
          ToastUtil.error(err);
          data.dataLoading = false;
          data.loading = false;
        })
  }

  const saveItem = () => {
    if (form.value.validate()) {
      data.loading = true
      ApiWrapper.post('disbursements-misc', 'create', {
            newDisbursement: data.newItem,
            claimId: props.contextIdA
          })
          .then((response) => {
            getData();
            getAdminData();
            getRuleData();
            discardItem()
            data.dataLoading = false;
            data.loading = false;
            ToastUtil.successMsg('Created disbursement');
          })
          .catch((err) => {
            ToastUtil.error(err);
            data.dataLoading = false;
            data.loading = false;
          })
    }
  }

  const discardItem = () => {
    data.newItem.amount = null
    data.newItem.description = null
    data.newItem.personid = null
    data.newDisb = false
  }

  const getRuleData = () => {
    ApiWrapper.get(
            'disbursement-rules',
            'disbursement-rules',
            'claimId='+props.contextIdA
        )
        .then((response) => {
          data.dataLoading = false;
          data.ruleLines = response.drules;
          data.rulePeople = response.people.map(function (obj) {
            return obj.name;
          });

          data.ruleCategories = response.categories.map(function (obj) {
            return obj.category;
          });
        })
        .catch((e)=>{
          ToastUtil.error(e);
          data.dataLoading = false;
        })
        .finally(()=>{
          data.dataLoading = false
        })
  }

  const generateRules = () => {
    data.dataLoading = true
    if(data.ruleLines.length > 0){
      if(confirm('This claim already had disbursement rules generated. Would you like to generate them again?')){
        ApiWrapper.get('disbursement-rules', 'generate', 'claimId=' + props.contextIdA)
            .then((response) => {
              getRuleData();
              getAdminData();
              getData()
              ToastUtil.successMsg('Generated disbursements');
            })
            .catch((err) => {
              ToastUtil.error(err);
              data.dataLoading = false;
            });
      }else{
        data.dataLoading = false
      }
    }else{
      ApiWrapper.get('disbursement-rules', 'generate','claimId=' + props.contextIdA)
          .then((response) => {
            getRuleData();
            getAdminData();
            getData();
            ToastUtil.successMsg('Generated disbursements');
          }).catch((err) => {
            ToastUtil.error(err);
            data.dataLoading = false;
          });
    }

}

  const deleteRuleItem = (item) => {
    let deleteMessage = confirm(
        'Are you sure you want to delete this item?'
    );
    if (deleteMessage === true) {
      data.loading = true;
      ApiWrapper.post('disbursement-rules', 'delete', {
            id: item.druleid,
            claimId: props.contextIdA
          })
          .then((response) => {
            data.loading = false;
            getRuleData();
            getData();
            getAdminData();
            ToastUtil.successMsg('Deleted disbursement rule');
          })
          .catch((err) => {
            ToastUtil.error(err);
            data.loading = false;
          });
    }
  }

  const saveRuleItem = () => {
    if (ruleForm.value.validate()) {
      data.loading = true;
      ApiWrapper.post('disbursement-rules', 'create', {
            newDRule: data.newRuleItem,
            claimId: props.contextIdA
          })
          .then((response) => {
            getRuleData();
            getAdminData()
            getData()
            discardRuleItem();
            data.loading = false;
            ToastUtil.successMsg('Updated disbursement rule');
          })
          .catch((err) => {
            ToastUtil.error(err);
            data.loading = false;
          });
    }
  }

  const discardRuleItem = () => {
    data.newRuleItem.name = null;
    data.newRuleItem.type = null;
    data.newRuleItem.value = null;
    data.newRuleItem.category = null;
    data.newRule = false;
  }

  onMounted(()=>{
    activeComponentStore.registerComponent(
        compName,
        [
          'disbursement-rules',
          'disbursements'
        ],
        getData
    );

    getData();
    getRuleData();
    getAdminData();
  });

onUnmounted(() => {
  activeComponentStore.deregisterComponent(compName);
});
</script>

<template>
  <v-container fluid>
    <v-card>
      <v-toolbar density="compact" flat color="white" class="title-content">
        <v-toolbar-title class="title-main">Disbursements</v-toolbar-title>
        <v-progress-linear
            :active="data.loading"
            :indeterminate="data.loading"
            absolute
            bottom
            color="primary"
        ></v-progress-linear>
        <v-divider class="mx-4" inset vertical></v-divider>

        <v-spacer></v-spacer>

        <v-btn size="small" variant="elevated" v-if="!data.newDisb && Permissions.checkPermissions(['disbursements.create'])" class="primary" @click="data.newDisb = true">
          + Fixed Disbursement
        </v-btn>
        <v-btn
            size="small"
            variant="elevated"
            color="primary"
            dark
            class="px-2 ml-2"
            v-if="Permissions.checkPermissions(['disbursement-rules.create'])"
            @click="data.newRule = true"
        >+ Disbursement</v-btn>
        <v-btn
            size="small"
            variant="elevated"
            color="primary"
            dark
            class="px-2 ml-2"
            @click="generateRules"
            v-if="Permissions.checkPermissions(['disbursement-rules.generate'])"
        >Generate</v-btn>
      </v-toolbar>


      <v-form
          ref="ruleForm"
          v-model="data.ruleValid"
          lazy-validation
          v-if="data.newRule"
      >
        <v-row class="px-5">
          <v-col cols="12" sm="2">
            <v-select
                :items="data.rulePeople"
                type="text"
                v-model="data.newRuleItem.name"
                label="Person"
                :rules="[v => !!v || 'A Person is required']"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="2">
            <v-text-field
                type="number"
                v-model="data.newRuleItem.value"
                label="Percentage"
                :rules="[v => !!v || 'Value is required']"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="2">
            <v-select
                :items="data.types"
                type="text"
                v-model="data.newRuleItem.type"
                label="Type"
                :rules="[v => !!v || 'Type is required']"
            ></v-select>
          </v-col>

          <v-col cols="12" sm="3">
            <v-select
                type="text"
                :items="data.ruleCategories"
                v-model="data.newRuleItem.category"
                label="Category"
                :rules="[v => !!v || 'Category is required']"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="3">
            <v-btn
                size="small"
                variant="elevated"
                class="px-2"
                @click="saveRuleItem"
                color="primary"
                :disabled="!data.ruleValid"
            >
              <v-icon color="white">mdi-plus</v-icon>
            </v-btn>
            <v-btn size="small" variant="elevated" class="px-2" @click="discardRuleItem" color="error">
              <v-icon color="white">mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>

      <div v-if="data.editingRuleItem === true">
        <v-form
            ref="form"
            v-model="data.valid"
            lazy-validation
        >
          <v-row class="px-5">
            <v-col cols="12" sm="2">
              <v-select
                  :items="data.rulePeople"
                  type="text"
                  v-model="data.editedRuleItem.drulerole"
                  label="Person"
                  :rules="[v => !!v || 'A Person is required']"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="3">
              <v-select
                  type="text"
                  :items="data.ruleCategories"
                  v-model="data.editedRuleItem.drulecategory"
                  label="Category"
                  :rules="[v => !!v || 'Category is required']"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="2">
              <v-select
                  :items="data.types"
                  type="text"
                  v-model="data.editedRuleItem.druletype"
                  label="Type"
                  :rules="[v => !!v || 'Type is required']"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="2">
              <v-text-field
                  v-model="data.editedRuleItem.drulevalue"
                  label="Percentage"
                  :rules="[v => !!v || 'Value is required']"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-btn
                  size="small"
                  variant="elevated"
                  class="px-2"
                  @click="editRuleItem()"
                  color="primary"
                  :disabled="!data.valid"
              >
                <v-icon color="white">mdi-plus</v-icon>
              </v-btn>
              <v-btn size="small" variant="elevated" class="px-2" @click="cancelEdit()" color="error">
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </div>

      <v-form
          ref="form"
          v-model="data.valid"
          lazy-validation
          v-if="data.newDisb"
      >
        <v-row class="px-5">
          <v-col cols="12" sm="2">
            <v-select
                v-model="data.newItem.personid"
                label="People"
                item-title="name"
                item-value="personid"
                :items="data.people"
                :rules="[v => !!v || 'People is required']"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="2">
            <v-text-field
                type="number"
                v-model="data.newItem.amount"
                label="Amount"
                :rules="[v => !!v || 'Amount is required']"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="5">
            <v-combobox
                v-model="data.newItem.description"
                label="Description"
                :items="descriptionOptions"
                :rules="[v => !!v || 'Description is required']"
                clearable
            ></v-combobox>
          </v-col>
          <v-col cols="12" sm="4">
            <v-btn
                size="small"
                variant="elevated"
                class="px-2"
                @click="saveItem"
                color="primary"
                :disabled="!data.valid"
            >
              <v-icon color="white">mdi-plus</v-icon>
            </v-btn>
            <v-btn size="small" variant="elevated" class="px-2" @click="discardItem" color="error">
              <v-icon color="white">mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>

      <v-form
          ref="form"
          v-if="data.editingFixed"
      >
        <v-row class="px-5">
          <v-col cols="12" sm="2">
            <v-text-field
                type="number"
                v-model="data.editedFixed.amountnum"
                label="Amount"
                :rules="[v => !!v || 'Amount is required']"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="5">
            <v-text-field
                v-model="data.editedFixed.description"
                label="Description"
                :rules="[v => !!v || 'Description is required']"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-btn
                size="small"
                variant="elevated"
                class="px-2"
                @click="editFixed"
                color="primary"
                :disabled="!data.valid"
            >
              <v-icon color="white">mdi-plus</v-icon>
            </v-btn>
            <v-btn size="small" variant="elevated" class="px-2" @click="data.editingFixed = false" color="error">
              <v-icon color="white">mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>

      <v-list density="compact">
        <v-list-item v-for="(item) in data.peopleRows" :key="item">
            <v-list-item-title style="font-size: 18px;">{{item.name}} | &emsp; {{item.previewAmount !== undefined ? 'Preview Total: ' + item.previewAmount : ''}} &emsp; {{item.amountReal !== undefined ? 'Total Paid: ' + item.amountReal : ''}}</v-list-item-title>
            <v-list-item-subtitle v-for="(disb) in data.lines.filter((d) => item.ids.includes(d.personid))" :key="disb">
              <div v-if="disb.invoiceid === 'Preview'">
                <span class="nowrap" style="font-size: 14px;" ><b>&emsp; To be paid ${{disb.amount}} from {{disb.value === '%' ? '' : disb.value + ' of'}}  {{disb.preamount !== undefined ? disb.preamount : ''}} {{disb.description}}</b></span>
                &emsp;
                <v-icon size="small" v-if="Permissions.checkPermissions(['disbursement-rules.update'])" @click="data.editingRuleItem=true; data.editedRuleItem=disb"> mdi-pencil </v-icon>
                <v-icon size="small" v-if="Permissions.checkPermissions(['disbursement-rules.delete'])" @click="deleteRuleItem(disb)"> mdi-delete </v-icon>
              </div>
              <div v-if="disb.invoiceid === 'Manual Entry Preview'">
                <span class="nowrap" style="font-size: 14px;" ><b>&emsp; To be paid {{disb.amount}} from {{disb.value === '%' ? '' : disb.value + ' of'}}  {{disb.preamount !== undefined ? disb.preamount : ''}} {{disb.description}}</b></span>
                &emsp;
                <v-icon size="small" v-if="Permissions.checkPermissions(['disbursements.update'])" @click="editingFixed=true; editedFixed = disb"> mdi-pencil </v-icon>
                <v-icon size="small" v-if="Permissions.checkPermissions(['disbursements.delete'])" @click="deleteItem(disb)"> mdi-delete </v-icon>
              </div>
              <div v-if="disb.invoiceid !== 'Preview' && disb.invoiceid !== 'Manual Entry Preview'">
                <span style="font-size: 14px;">&emsp; Paid {{disb.amount}} from {{disb.value === '%' ? '' : disb.value + ' of'}}  {{disb.preamount !== undefined ? disb.preamount : ''}} {{disb.description}}</span>
              </div>
            </v-list-item-subtitle>
        </v-list-item>
      </v-list>


      <v-toolbar flat color="white" class="pt-4">
        <v-toolbar-title>Company Total</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <p> {{'$' + data.total.toFixed(2) + ' : Admin Fees - ($' + data.adminFee + ' + ' + data.nonHiddenAdmin + ')'}}</p>
        <v-spacer></v-spacer>
        <v-text-field @change="updateFee(false)" :disabled="!Permissions.checkPermissions(['claims.change-admin-fee'])" type="number" class='pa-3; shrink' label='Hidden Admin Fee' v-model="data.adminFee" prefix="$">
        </v-text-field>
      </v-toolbar>
    </v-card>
  </v-container>
</template>

<style scoped>
  .container {
    padding: 5px;
  }
  [v-cloak] {
    display: none;
  }
  .title-content {
    align-items: center;
    display: flex;
    position: relative;
    z-index: 0;
  }
  .title-main {
    font-size: 1.25rem;
    line-height: 1.5;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .v-spacer {
    flex-grow: 0!important;
  }
</style>